import { Icons } from '@cast/design-system';

import { PRODUCT_BASE_PATHS } from '@cast/console-constants';

import { SidebarItem } from '../../_components/SidebarItem';
import { SidebarItemBadge } from '../../_components/SidebarItemBadge';
import { SidebarLayout } from '../../_components/SidebarLayout';
import { SidebarSection } from '../../_components/SidebarSection';

export const DboSidebarV1 = () => {
  const basePath = PRODUCT_BASE_PATHS.dbo;

  return (
    <SidebarLayout
      title="Database"
      subtitle="Monitor & optimize"
      icon={
        <Icons.CastDatabaseOptimization
          variant="preset"
          weight="light"
          size={24}
        />
      }
    >
      <SidebarSection>
        <SidebarItem
          title="Caches"
          url={`${basePath}/caches`}
          allowedInReadOnlyOrg
        />
        <SidebarItem title="Databases" url={`${basePath}/cloud-databases`} />
        <SidebarItem
          title="Performance advisor"
          url={`${basePath}/performance-advisor`}
          endAdornment={<SidebarItemBadge>NEW</SidebarItemBadge>}
        />
      </SidebarSection>
    </SidebarLayout>
  );
};
